import debounce from "lodash/debounce";
import { useCallback, useState } from "react";

import { useCan } from "components";
import { useTypedMutation } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { ApiInstance } from "utils/Api";

import type { Pin } from "models";

const DEBOUNCE_DURATION = 250;

export const useCreateManufacturerRequestModal = () => {
  const canCreateRequest = useCan(ACL_ACTIVITIES.Create, ACL_RESOURCES.ManufacturerRequest);

  const [pinClaims, setPinClaims] = useState<Pin[]>([]);
  const [showCreateRequestModal, setShowCreateRequestModal] = useState(false);

  const { mutate: searchPinClaims, isPending: isSearchingPin } = useTypedMutation<string, Pin[]>({
    mutationFn: async claim_nr => (await ApiInstance.post("/pins/search_by_claim_nr", { claim_nr })).data?.pins ?? [],
    onSuccess: (_, pins) => setPinClaims(pins)
  });

  const closeCreateRequestModal = () => setShowCreateRequestModal(false);
  const openCreateRequestModal = () => setShowCreateRequestModal(true);

  const debouncedSearch = useCallback(debounce(searchPinClaims, DEBOUNCE_DURATION), []);

  const searchManufacturerClaim = (searchTerm: string) => {
    if (!searchTerm || !canCreateRequest) return;

    debouncedSearch(searchTerm);
  };

  return { searchManufacturerClaim, pinClaims, showCreateRequestModal, closeCreateRequestModal, openCreateRequestModal, isSearchingPin };
};
